import { coordinatorRootApi } from "@/lib/api";

export const rejectInvitation = async ({
  invitationId,
}: {
  invitationId: string;
}): Promise<void> => {
  await coordinatorRootApi.post(`/invitations/${invitationId}/reject`);
};
